import { Controller, useForm, useFormContext } from 'react-hook-form';
import React, { useEffect, useMemo, useState } from 'react';
import { Translate, useTranslate } from '~/i18n';
import { successMessage } from '~/utils/toasts';

import Axios from '~/utils/axios';
import { RequestFooter } from './request-footer';
import { sentryCaptureException } from '~/errors/sentry';
import { useRouter } from 'next/router';
import { renderErrorsToToaster } from './render-error-to-toaster';
import cn from 'classnames';
import { DatePicker, Input, UISelect } from '../common/forms';
import { DateTime } from 'luxon';
import { Button } from '../common/button';
import { TrashIconOutline } from '~/svgs';
import { AddButton } from '../common/button/add';
export const MoreInformation = ({ questionsList, countriesList }: any) => {
   const { translate, lang } = useTranslate();
   const { reset, getValues } = useFormContext<any>();
   const formValues = getValues();
   const {
      register,
      control,
      handleSubmit,
      setValue,
      getValues: getFormValues,
      formState: { errors },
      watch,
   } = useForm<any>();
   const router = useRouter();
   const [loading, setLoading] = useState(false);
   const [answeredQuestionsList, setAnsweredQuestionsList] = useState<string[]>([]);
   const [additionalValues, setAdditionalValues] = useState<any>(
      (formValues?.additionalValues as any) || (getFormValues('additionalValues') as any) || [{}]
   );
   const sentAdditionalValues = getFormValues('additionalValues');

   useEffect(() => {
      setAdditionalValues(sentAdditionalValues);
   }, [sentAdditionalValues]);

   const handleAddValues = () => {
      if (
         (answeredQuestionsList?.[0] === 'YES' && questionsList[0]?.id === 1) ||
         answeredQuestions?.[0]?.[questionsList[0]?.id] === 'YES'
      ) {
         // If there are no additional values, add one with empty values
         if (!additionalValues || additionalValues?.length === 0) {
            setAdditionalValues([{ countryCode: '', purpose: '', fromDate: '', toDate: '' }]);
         } else {
            // Otherwise, add a new empty object
            setAdditionalValues([...additionalValues, {}]);
         }
      }
   };

   const handleRemoveValues = (index: number) => {
      const updatedValues = [...additionalValues];
      updatedValues.splice(index, 1);
      setAdditionalValues(updatedValues);
   };

   const { id, applicationNo } = router.query;

   const answeredQuestions = useMemo(() => {
      return formValues?.mofaquestionnaire?.map((question: any, i: any) => {
         if (i === 0) {
            const jsonContent = question?.comment?.replace(/^"|"$/g, '');
            const data = jsonContent ? JSON?.parse(jsonContent) : [];
            // // Assuming 'comment' is an array with objects
            // const commentArray = data.map((item: any) => ({
            //    countryCode: item.countryCode ?? '',
            //    purpose: item.purpose ?? '',
            //    fromDate: item.fromDate ?? '',
            //    toDate: item.toDate ?? '',
            // }));

            // // Update form values using setValue
            data?.forEach?.((item: any, index: number) => {
               setValue(`additionalValues[${index}].countryCode`, item.countryCode);
               setValue(`additionalValues[${index}].purpose`, item.purpose);
               setValue(`additionalValues[${index}].fromDate`, item.fromDate);
               setValue(`additionalValues[${index}].toDate`, item.toDate);
            });
         }
         if (i === 3) {
            try {
               const jsonContent = question?.comment?.replace(/^"|"$/g, '');
               if (jsonContent) {
                  const data = jsonContent ? JSON?.parse(jsonContent) : [];
                  const name = data[0]?.name ?? '';
                  const relationship = data[0]?.relationShip ?? '';
                  setValue('name', name);
                  setValue('relationship', relationship);
               }
            } catch (error) {
               console.log(error);
            }
         }
         return {
            [question?.question]: question?.answer,
            comment: question?.comment,
         };
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [formValues?.mofaquestionnaire, lang]);

   const handleRadioChange = (questionId: number, value: string) => {
      const updatedAnsweredQuestionsList = [...answeredQuestionsList];
      updatedAnsweredQuestionsList[questionId - 1] = value;
      setAnsweredQuestionsList(updatedAnsweredQuestionsList);
      setValue(`mofaquestionnaire.[${questionId}].answer`, value);
   };

   const CompanionTypeOptions = [
      {
         value: 'SON',
         label: translate({ id: 'visasManager:son' }),
      },
      {
         value: 'FATHER',
         label: translate({ id: 'visasManager:father' }),
      },
      {
         value: 'BROTHER',
         label: translate({ id: 'visasManager:brother' }),
      },
      {
         value: 'HUSBAND',
         label: translate({ id: 'visasManager:husband' }),
      },
      {
         value: 'GRANDPA',
         label: translate({ id: 'visasManager:grandpa' }),
      },
      {
         value: 'NEPHEW',
         label: translate({ id: 'visasManager:nephew' }),
      },
      {
         value: 'GRANDSON',
         label: translate({ id: 'visasManager:grandson' }),
      },
      {
         value: 'UNCLE',
         label: translate({ id: 'visasManager:uncle' }),
      },
      {
         value: 'DAUGHTER_HUSBAND',
         label: translate({ id: 'visasManager:daughter husband' }),
      },
      {
         value: 'STEPFATHER',
         label: translate({ id: 'visasManager:stepfather' }),
      },
      {
         value: 'FATHER_IN_LAW',
         label: translate({ id: 'visasManager:father in law' }),
      },
   ];

   const submitForm = async (values: any) => {
      setLoading(true);
      const mofaquestionnaire = Object.keys(values?.mofaquestionnaire).map(questionId => {
         const handleComment = () => {
            const relationShip = values?.relationship ?? getValues('relationship') ?? '';
            const name = values?.name ?? getValues('name') ?? '';
            const countryValues = getFormValues('additionalValues');
            // Handle additional values
            const additionalValuesComments = countryValues?.map((additionalValue: any) => {
               const countryCode = additionalValue?.countryCode ?? '';
               const purpose = additionalValue?.purpose ?? '';
               const fromDate = additionalValue?.fromDate ?? '';
               const toDate = additionalValue?.toDate ?? '';
               return {
                  countryCode,
                  purpose,
                  fromDate,
                  toDate,
               };
            });

            if (questionId == '1') {
               return additionalValuesComments;
            } else if (questionId == '4') {
               return { name, relationShip };
            } else return values?.[questionId]?.comment;
         };
         return {
            question: parseInt(questionId),
            answer: values?.mofaquestionnaire?.[questionId].answer,
            comment:
               values?.mofaquestionnaire?.[questionId]?.answer?.toLowerCase?.() === 'yes'
                  ? handleComment() || ''
                  : '',
         };
      });

      const body = {
         visitors: [
            {
               mofaquestionnaire,
            },
         ],
         current_step: 'applicant_more_information',
      };
      try {
         await Axios.put(`/dhamen/v1/visa-request/${id}/visitors/${applicationNo}`, body);
         await Axios.patch(`/dhamen/v1/visa-request/${id}`, {
            current_step: 'applicant_done',
         });
         reset({ ...getValues(), ...values });
         successMessage(translate({ id: 'visasManager:applicant added successfully' }));
         router.push(`/${lang}/umrah-requests/${id}`);
      } catch (error: any) {
         console.log(error);
         sentryCaptureException(error);
         renderErrorsToToaster(error?.response?.data);
         reset({ ...getValues(), ...values });
      }
      setLoading(false);
   };

   const selectAllOptions = (value: string) => {
      const updatedAnsweredQuestionsList = Array(questionsList.length).fill(value);
      setAnsweredQuestionsList(updatedAnsweredQuestionsList);
      questionsList.forEach((question: any) => {
         setValue(`mofaquestionnaire.[${question?.id}].answer`, value);
      });
   };

   return (
      <>
         <div>
            <div
               className={cn(
                  'flex items-center justify-between w-full gap-4 mb-8 lg:flex-nowrap flex-wrap'
               )}>
               <div className="w-full gap-1 text-xl font-bold lg:w-3/4 text-primary">
                  <Translate id="visasManager:more information" />
               </div>
               <div className="flex items-end justify-between w-full gap-2 lg:w-1/4">
                  <Button theme="outline-primary" onClick={() => selectAllOptions('YES')}>
                     <Translate id="visasManager:all yes" />
                  </Button>
                  <Button theme="outline-primary" onClick={() => selectAllOptions('NO')}>
                     <Translate id="visasManager:all no" />
                  </Button>
               </div>
            </div>

            <div className="w-full">
               <form onSubmit={handleSubmit(submitForm)}>
                  {questionsList?.map((question: any) => (
                     <div
                        className="flex flex-col py-8 border-b border-gray-200 first:pt-0 last:border-none"
                        key={question?.id}>
                        <div
                           className={cn(
                              'flex items-center justify-between w-full gap-4 lg:flex-nowrap flex-wrap'
                           )}>
                           <div className="w-full gap-1 font-semibold lg:w-3/4 sm:text-base">
                              {lang === 'ar' ? question?.questionAr : question?.questionEn}
                              <span className="text-red">*</span>
                           </div>
                           <div className="flex items-end justify-between gap-4 w-fit lg:w-1/4">
                              <Controller
                                 name={`mofaquestionnaire.[${question?.id}].answer`}
                                 control={control}
                                 render={() => (
                                    <>
                                       <label className="flex items-center space-x-4 cursor-pointer w-fit shrink-0 rtl:space-x-reverse">
                                          <input
                                             type="radio"
                                             value="YES"
                                             {...register(
                                                `mofaquestionnaire.${question?.id}.answer`,
                                                {
                                                   required: translate({
                                                      id: 'validation:required',
                                                   }),
                                                }
                                             )}
                                             className={cn(
                                                errors[question?.id] && '!border-states-error'
                                             )}
                                             defaultChecked={
                                                answeredQuestions?.[question?.id - 1]?.[
                                                   question?.id
                                                ] === 'YES' ||
                                                watch(
                                                   `mofaquestionnaire.${question?.id}.answer`
                                                ) === 'YES'
                                             }
                                             onChange={() => handleRadioChange(question?.id, 'YES')}
                                          />
                                          <span
                                             className={cn(
                                                errors[question?.id] && 'text-states-error'
                                             )}>
                                             <Translate id="common:yes" />
                                          </span>
                                       </label>
                                       <label className="flex items-center space-x-4 cursor-pointer w-fit shrink-0 rtl:space-x-reverse">
                                          <input
                                             type="radio"
                                             value="NO"
                                             {...register(
                                                `mofaquestionnaire.${question?.id}.answer`,
                                                {
                                                   required: translate({
                                                      id: 'validation:required',
                                                   }),
                                                }
                                             )}
                                             className={cn(
                                                errors[question?.id] && '!border-states-error'
                                             )}
                                             defaultChecked={
                                                answeredQuestions?.[question?.id - 1]?.[
                                                   question?.id
                                                ] === 'NO' ||
                                                watch(
                                                   `mofaquestionnaire.${question?.id}.answer`
                                                ) === 'NO'
                                             }
                                             onChange={() => handleRadioChange(question?.id, 'NO')}
                                          />
                                          <span
                                             className={cn(
                                                errors[question?.id] && 'text-states-error'
                                             )}>
                                             <Translate id="common:no" />
                                          </span>
                                       </label>
                                    </>
                                 )}
                              />
                           </div>
                        </div>
                        {errors[question.id] && (
                           <div className="mt-1 text-xs text-states-error">
                              {errors?.[question?.id]?.message as any}
                           </div>
                        )}
                        {(answeredQuestionsList?.[question.id - 1] === 'YES' ||
                           answeredQuestions?.[question.id - 1]?.[question.id] === 'YES') &&
                           question.id != 1 &&
                           question.id != 4 && (
                              <Input
                                 type="text"
                                 id={`${question?.id}.comment`}
                                 className="mt-2"
                                 placeholder={translate({ id: 'visasManager:comment' })}
                                 {...register(`${question.id}.comment`, {
                                    required:
                                       question.id == 3 || question.id == 16
                                          ? false
                                          : translate({ id: 'validation:required' }),
                                    minLength: {
                                       value: 3,
                                       message: translate({
                                          id: 'validation:min characters',
                                          values: {
                                             count: String(3),
                                          },
                                       }),
                                    },
                                    maxLength: {
                                       value: 100,
                                       message: translate({
                                          id: 'validation:max characters',
                                          values: {
                                             count: String(100),
                                          },
                                       }),
                                    },
                                 })}
                                 defaultValue={answeredQuestions?.[question?.id - 1]?.comment ?? ''}
                              />
                           )}
                        {(errors as any)?.[question.id]?.comment && (
                           <div className="mt-1 text-xs text-states-error">
                              {(errors as any)?.[question?.id]?.comment?.message}
                           </div>
                        )}
                        {((answeredQuestionsList?.[0] === 'YES' && question.id == 1) ||
                           answeredQuestions?.[0]?.[question.id] === 'YES') && (
                           <>
                              {additionalValues?.map((_: any, index: any) => (
                                 <div key={index}>
                                    <div className="mt-4">
                                       <Controller
                                          name={`additionalValues[${index}].countryCode`}
                                          control={control}
                                          rules={{
                                             required:
                                                answeredQuestionsList?.[0] === 'YES' &&
                                                question.id === 1
                                                   ? translate({ id: 'validation:required' })
                                                   : false,
                                          }}
                                          render={({ field: { onChange, value } }) => (
                                             <UISelect
                                                label={translate({
                                                   id: 'visasManager:select country',
                                                })}
                                                id={`additionalValues[${index}].countryCode`}
                                                value={countriesList?.find(
                                                   (opt: any) => opt.value === value
                                                )}
                                                options={countriesList}
                                                error={
                                                   errors[`additionalValues[${index}].countryCode`]
                                                      ?.message
                                                }
                                                onChange={({ value }: any) => onChange(value)}
                                                isRequired
                                             />
                                          )}
                                       />
                                    </div>

                                    <Input
                                       type="text"
                                       id={`additionalValues[${index}].purpose`}
                                       className="mt-2"
                                       label={translate({ id: 'visasManager:purpose' })}
                                       {...register(`additionalValues[${index}].purpose`, {
                                          required:
                                             answeredQuestionsList?.[0] === 'YES' &&
                                             question.id === 1
                                                ? translate({ id: 'validation:required' })
                                                : false,
                                          maxLength: {
                                             value: 100,
                                             message: translate({
                                                id: 'validation:max characters',
                                                values: {
                                                   count: String(100),
                                                },
                                             }),
                                          },
                                       })}
                                       error={errors[`additionalValues[${index}].purpose`]?.message}
                                       isRequired
                                    />
                                    <div className="flex flex-col items-start justify-between gap-4 mt-1 lg:flex-row">
                                       <Controller
                                          control={control}
                                          name={`additionalValues[${index}].fromDate`}
                                          rules={{
                                             required:
                                                answeredQuestionsList?.[0] === 'YES' &&
                                                question.id === 1
                                                   ? translate({ id: 'validation:required' })
                                                   : false,
                                          }}
                                          render={({ field: { onChange, value } }) => (
                                             <DatePicker
                                                placeholderText={translate({
                                                   id: 'discountSchedule:select date',
                                                })}
                                                id={`additionalValues[${index}].fromDate`}
                                                label={translate({
                                                   id: 'discountSchedule:date from',
                                                })}
                                                maxDate={new Date()}
                                                value={value?.split?.('T')?.[0] || value}
                                                error={
                                                   errors[`additionalValues[${index}].fromDate`]
                                                      ?.message
                                                }
                                                onChange={val => {
                                                   const d = DateTime.fromJSDate(val as Date);
                                                   onChange(d.toFormat('yyyy-MM-dd'));
                                                   setValue(
                                                      `additionalValues[${index}].toDate`,
                                                      ''
                                                   );
                                                }}
                                                groupClassName="w-full lg:w-1/2"
                                                isRequired
                                             />
                                          )}
                                       />
                                       <Controller
                                          control={control}
                                          name={`additionalValues[${index}].toDate`}
                                          rules={{
                                             required:
                                                answeredQuestionsList?.[0] === 'YES' &&
                                                question.id === 1
                                                   ? translate({ id: 'validation:required' })
                                                   : false,
                                          }}
                                          render={({ field: { onChange, value } }) => (
                                             <DatePicker
                                                placeholderText={translate({
                                                   id: 'discountSchedule:select date',
                                                })}
                                                id={`additionalValues[${index}].toDate`}
                                                minDate={
                                                   getFormValues(
                                                      `additionalValues[${index}].fromDate`
                                                   ) &&
                                                   DateTime.fromFormat(
                                                      getFormValues(
                                                         `additionalValues[${index}].fromDate`
                                                      ),
                                                      'yyyy-MM-dd'
                                                   )?.isValid
                                                      ? DateTime.fromFormat(
                                                           getFormValues(
                                                              `additionalValues[${index}].fromDate`
                                                           ),
                                                           'yyyy-MM-dd'
                                                        ).toJSDate()
                                                      : null
                                                }
                                                maxDate={new Date()}
                                                label={translate({
                                                   id: 'discountSchedule:date to',
                                                })}
                                                value={value?.split?.('T')?.[0] || value}
                                                error={
                                                   errors[`additionalValues[${index}].toDate`]
                                                      ?.message
                                                }
                                                onChange={val => {
                                                   const d = DateTime.fromJSDate(val as Date);
                                                   onChange(d.toFormat('yyyy-MM-dd'));
                                                }}
                                                groupClassName="w-full lg:w-1/2"
                                                isRequired
                                             />
                                          )}
                                       />
                                    </div>
                                    {additionalValues?.length != 1 && (
                                       <button
                                          type="button"
                                          onClick={() => handleRemoveValues(index)}
                                          className="flex items-center justify-end w-full gap-2 mt-2 text-states-error hover:text-red-700 focus:outline-none">
                                          <TrashIconOutline />
                                          <Translate id="common:delete" />
                                       </button>
                                    )}
                                 </div>
                              ))}

                              <div className="mt-4">
                                 <AddButton
                                    onClick={handleAddValues}
                                    title={<Translate id="visasManager:add country" />}
                                 />
                              </div>
                           </>
                        )}

                        {((answeredQuestionsList?.[4 - 1] === 'YES' && question.id == 4) ||
                           answeredQuestions?.[3]?.[question.id] === 'YES') && (
                           <>
                              <div className="mt-4">
                                 <Input
                                    type="text"
                                    id={`name`}
                                    label={translate({ id: 'visasManager:name' })}
                                    {...register(`name`, {
                                       required:
                                          answeredQuestionsList?.[4 - 1] === 'YES' &&
                                          question.id == 4
                                             ? translate({ id: 'validation:required' })
                                             : false,
                                       minLength: {
                                          value: 3,
                                          message: translate({
                                             id: 'validation:min characters',
                                             values: {
                                                count: String(3),
                                             },
                                          }),
                                       },
                                       maxLength: {
                                          value: 100,
                                          message: translate({
                                             id: 'validation:max characters',
                                             values: {
                                                count: String(100),
                                             },
                                          }),
                                       },
                                    })}
                                    error={errors.name?.message}
                                    isRequired
                                 />
                              </div>
                              <Controller
                                 name="relationship"
                                 control={control}
                                 rules={{
                                    required: translate({ id: 'validation:required' }),
                                 }}
                                 render={({ field: { onChange, value } }) => (
                                    <UISelect
                                       label={translate({
                                          id: 'visasManager:relationship',
                                       })}
                                       id="relationship"
                                       name="relationship"
                                       value={CompanionTypeOptions.find(
                                          (opt: any) => opt.value === value
                                       )}
                                       options={CompanionTypeOptions}
                                       error={errors.relationship?.message}
                                       onChange={({ value }: any) => onChange(value)}
                                       isRequired
                                    />
                                 )}
                              />
                           </>
                        )}
                     </div>
                  ))}
               </form>
            </div>
         </div>
         <RequestFooter
            fwdBtnHandler={handleSubmit(submitForm)}
            fwdBtnLabel={translate({ id: 'visasManager:add applicant' })}
            cancelBtnHandler={() => router.back()}
            loading={loading}
         />
      </>
   );
};
